module.exports = __webpack_public_path__ + "assets/img/打破产品鸿沟，产生涟漪效益.3958918b.jpg";